import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function HomePage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [isComicModalOpen, setIsComicModalOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

    const schemas = [
      {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: 'パタカラ®公式施設ライセンス | 介護施設・医療施設向け月額770円',
        description: '月額770円（税込）で登録商標「パタカラ®」の正式な使用許諾を取得。介護施設・医療施設限定の公式ライセンスサービス。',
        url: `${siteUrl}/`,
        inLanguage: 'ja',
        isPartOf: {
          '@type': 'WebSite',
          name: 'パタカラ®公式施設ライセンス',
          url: `${siteUrl}/`,
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'LocalBusiness',
        name: '株式会社パックスシステムズ',
        description: '登録商標「パタカラ®」（登録第5657576号）の商標権者。介護施設・医療施設向け公式ライセンスサービスを提供。',
        url: `${siteUrl}/`,
        telephone: '045-681-3165',
        faxNumber: '045-681-3173',
        email: 'info@patakara.org',
        address: {
          '@type': 'PostalAddress',
          streetAddress: '山下町1番地 シルクセンターM1F',
          addressLocality: '横浜市中区',
          addressRegion: '神奈川県',
          postalCode: '231-0023',
          addressCountry: 'JP',
        },
        geo: {
          '@type': 'GeoCoordinates',
          latitude: 35.4437,
          longitude: 139.638,
        },
        openingHoursSpecification: [
          {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
            opens: '09:00',
            closes: '18:00',
          },
        ],
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Service',
        name: 'パタカラ®公式施設ライセンス',
        description: '登録商標「パタカラ®」の商標使用許諾サービス。介護施設・医療施設限定。月額770円（税込）。',
        provider: {
          '@type': 'Organization',
          name: '株式会社パックスシステムズ',
        },
        areaServed: {
          '@type': 'Country',
          name: 'Japan',
        },
        audience: {
          '@type': 'Audience',
          audienceType: '介護施設・医療施設',
        },
        offers: {
          '@type': 'Offer',
          price: '770',
          priceCurrency: 'JPY',
          priceSpecification: {
            '@type': 'UnitPriceSpecification',
            price: '770',
            priceCurrency: 'JPY',
            unitText: '月額（税込）',
          },
        },
        url: `${siteUrl}/`,
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: 'なぜ「パタカラ」の使用にライセンスが必要なのですか？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '「パタカラ」は、株式会社パックスシステムズが保有する法的な登録商標（第5657576号）だからです。一般名詞（介護・医療用語）ではないため、営利目的（施設でのサービス提供、集客、WEBサイトやパンフレットへの掲載）で無断使用することは商標権侵害にあたる法的リスクがあります。当ライセンスは、施設様が安心・安全に、かつコンプライアンスを遵守して名称をご利用いただくための正規の使用許諾制度です。',
            },
          },
          {
            '@type': 'Question',
            name: '月額770円（税込）のほかに、初期費用や更新料はかかりますか？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'いいえ、初期費用や更新料などは一切かかりません。1施設あたり月額770円（税込）のみでご利用いただけます。また、最低利用期間などの「契約の縛り」もございませんので、いつでも解約が可能です。',
            },
          },
          {
            '@type': 'Question',
            name: 'ライセンスを契約すると、指導用の教材や音源、器具などは届きますか？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '本ライセンスは「パタカラ®」の商標（名称・ロゴ）の使用許諾のみを提供するものです。そのため、実際の指導用マニュアル、教材、CD音源、または物理的なトレーニング器具などは含まれておりません。各施設様の責任のもとで、独自のレクリエーションや口腔機能向上サービスとして運用をお願いいたします。',
            },
          },
          {
            '@type': 'Question',
            name: '1つの法人で複数のデイサービスを運営している場合、契約は1つで足りますか？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'いいえ、本ライセンスは「1施設（1事業所）ごと」のご契約となります。同一法人であっても、運営されている施設・事業所の数だけライセンスのご契約が必要となりますのでご注意ください。',
            },
          },
          {
            '@type': 'Question',
            name: '申し込み後、公式施設認定証はいつ、どのように届きますか？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Webからの決済手続きとお申し込みフォームへの入力が完了した後、弊社での確認を経て最短2営業日以内に、ご登録いただいたメールアドレス宛に「公式施設認定証（PDF形式）」と「ロゴデータ（JPG/PNG形式）」を送付いたします。PDFは印刷して施設内に掲示したり、ロゴはホームページに掲載してご活用いただけます。',
            },
          },
          {
            '@type': 'Question',
            name: '支払方法は？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '「会費ペイ」のシステムを使用してお支払いください。',
            },
          },
          {
            '@type': 'Question',
            name: '非営利の公共性の高い団体及び、官公庁に関してはライセンスが必要ですか？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '非営利の公共性の高い団体及び、官公庁に関してもライセンスが必要です。非営利の健康増進・福祉活動等に限り、無償での商標使用許諾を検討しております。お問合せフォームよりご連絡ください。',
            },
          },
          {
            '@type': 'Question',
            name: '解約したい場合はどのようにすればよいですか？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'マイページ（会費ペイ等の決済画面）またはお問い合わせフォームより、解約希望月の指定期日までにお手続きいただくことで、いつでも違約金なしで解約が可能です。ただし、解約後は「パタカラ」の名称・ロゴ、および公式施設認定証は一切ご利用いただけなくなります（WEBサイトやパンフレットからの削除が必要です）。',
            },
          }
        ]
      }
    ];

    const existingScripts = document.querySelectorAll('script[data-schema="home"]');
    existingScripts.forEach((s) => s.remove());

    schemas.forEach((schema) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-schema', 'home');
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    });

    return () => {
      document.querySelectorAll('script[data-schema="home"]').forEach((s) => s.remove());
    };
  }, []);

  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const scrollToForm = () => {
    const formSection = document.getElementById('application-form');
    if (formSection) {
      formSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white/95 backdrop-blur-sm shadow-sm">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img 
              src="https://static.readdy.ai/image/1827e98d95d9f7558266c3fb82d75725/927c3b547f45ed1f38c15098c60865bf.png" 
              alt="パタカラ®ロゴ" 
              className="h-12 w-auto object-contain"
            />
          </div>
          <div className="hidden md:flex items-center gap-8">
            <a href="#overview" className="text-sm font-medium text-gray-700 hover:text-orange-500 transition-colors">概要</a>
            <a href="#features" className="text-sm font-medium text-gray-700 hover:text-orange-500 transition-colors">できること</a>
            <a href="#details" className="text-sm font-medium text-gray-700 hover:text-orange-500 transition-colors">詳細</a>
            <a href="#flow" className="text-sm font-medium text-gray-700 hover:text-orange-500 transition-colors">申込の流れ</a>
            <a href="#faq" className="text-sm font-medium text-gray-700 hover:text-orange-500 transition-colors">FAQ</a>
            <Link to="/trademark-guidelines" className="text-sm font-medium text-gray-700 hover:text-orange-500 transition-colors">商標利用ガイドライン</Link>
            <Link to="/contact" className="text-sm font-medium text-gray-700 hover:text-orange-500 transition-colors">お問合せ</Link>
            <Link
              to="/license-application"
              className="px-6 py-2.5 bg-orange-500 text-white text-sm font-semibold rounded-full hover:bg-orange-600 transition-all whitespace-nowrap cursor-pointer"
            >
              申込む
            </Link>
          </div>
          {/* Mobile hamburger */}
          <button
            className="md:hidden p-2 text-gray-700 cursor-pointer"
            aria-label={mobileMenuOpen ? 'メニューを閉じる' : 'メニューを開く'}
            aria-expanded={mobileMenuOpen}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </nav>

      {/* Mobile Menu Dropdown */}
      {mobileMenuOpen && (
        <div className="fixed top-[72px] left-0 right-0 z-40 bg-white border-t border-gray-200 shadow-lg md:hidden">
          <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col gap-1">
            <a
              href="#overview"
              className="flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-100 transition-colors cursor-pointer"
              onClick={() => setMobileMenuOpen(false)}
            >
              <i className="ri-information-line text-lg w-5 h-5 flex items-center justify-center text-gray-400"></i>
              概要
            </a>
            <a
              href="#features"
              className="flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-100 transition-colors cursor-pointer"
              onClick={() => setMobileMenuOpen(false)}
            >
              <i className="ri-star-line text-lg w-5 h-5 flex items-center justify-center text-gray-400"></i>
              できること
            </a>
            <a
              href="#details"
              className="flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-100 transition-colors cursor-pointer"
              onClick={() => setMobileMenuOpen(false)}
            >
              <i className="ri-file-list-3-line text-lg w-5 h-5 flex items-center justify-center text-gray-400"></i>
              詳細
            </a>
            <a
              href="#flow"
              className="flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-100 transition-colors cursor-pointer"
              onClick={() => setMobileMenuOpen(false)}
            >
              <i className="ri-guide-line text-lg w-5 h-5 flex items-center justify-center text-gray-400"></i>
              申込の流れ
            </a>
            <a
              href="#faq"
              className="flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-100 transition-colors cursor-pointer"
              onClick={() => setMobileMenuOpen(false)}
            >
              <i className="ri-question-line text-lg w-5 h-5 flex items-center justify-center text-gray-400"></i>
              FAQ
            </a>
            <Link
              to="/trademark-guidelines"
              className="flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-100 transition-colors cursor-pointer"
              onClick={() => setMobileMenuOpen(false)}
            >
              <i className="ri-shield-check-line text-lg w-5 h-5 flex items-center justify-center text-gray-400"></i>
              商標利用ガイドライン
            </Link>
            <Link
              to="/contact"
              className="flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-100 transition-colors cursor-pointer"
              onClick={() => setMobileMenuOpen(false)}
            >
              <i className="ri-mail-line text-lg w-5 h-5 flex items-center justify-center text-gray-400"></i>
              お問合せ
            </Link>
            <Link
              to="/license-application"
              onClick={() => setMobileMenuOpen(false)}
              className="flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-semibold text-white bg-orange-500 hover:bg-orange-600 transition-all cursor-pointer mt-2"
            >
              <i className="ri-edit-line text-lg w-5 h-5 flex items-center justify-center"></i>
              申込む
            </Link>
          </div>
        </div>
      )}

      {/* Hero Section */}
      <section className="relative pt-32 pb-24 overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://static.readdy.ai/image/1827e98d95d9f7558266c3fb82d75725/964186f638194f5de2dd7d42dcd87c67.jpeg" 
            alt="介護施設の明るい雰囲気" 
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-white/85 via-white/70 to-white/90"></div>
        </div>
        
        <div className="relative max-w-5xl mx-auto px-6 text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br from-amber-400 to-orange-500 mb-6 shadow-lg">
            <span className="text-white font-bold text-sm">公式</span>
          </div>
          
          <h1 className="text-6xl font-black text-slate-800 mb-4 tracking-tight">
            パタカラ®公式ライセンス
          </h1>
          
          <p className="text-2xl text-gray-600 mb-8 font-light">
            介護施設・医療施設向けライセンスサービス
          </p>
          
          <div className="mb-10">
            <div className="inline-block">
              <p className="text-lg text-gray-600 mb-2">月額</p>
              <p className="text-7xl font-black text-orange-500 mb-1">
                770<span className="text-4xl">円</span>
              </p>
              <p className="text-lg text-gray-500">（税込）</p>
            </div>
          </div>
          
          <Link
            to="/license-application"
            className="inline-flex items-center gap-3 px-16 py-6 bg-white text-orange-600 text-lg font-bold rounded-full shadow-2xl whitespace-nowrap cursor-pointer hover:bg-orange-50 transition-colors"
          >
            申込フォームへ進む
            <i className="ri-arrow-right-line text-2xl"></i>
          </Link>
        </div>
      </section>

      {/* Target Facilities Section */}
      <section className="py-20 bg-orange-50">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-3xl font-serif font-bold text-slate-800 text-center mb-4">
            介護・医療の現場で、そのまま導入できます。
          </h2>
          <p className="text-center text-gray-700 mb-6 text-base font-semibold">
            介護施設・医療施設において、パタカラを使用する場合は、必ずパタカラ®公式ライセンスが必要です。（施設での紙資料・WEB掲載・施設でのカラオケを使用したプログラム・口腔体操として実施など）
          </p>
          <p className="text-center text-gray-600 mb-14 text-base">
            パタカラ®は、以下のような施設でご活用いただけます。
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-10">
            {/* 介護施設 */}
            <div className="bg-white rounded-2xl p-8">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-orange-100">
                  <i className="ri-home-heart-line text-orange-500 text-xl"></i>
                </div>
                <h3 className="text-lg font-bold text-slate-800">対象となる介護施設</h3>
              </div>
              <ol className="space-y-3 mb-4">
                {[
                  '特別養護老人ホーム（特養）',
                  '介護老人保健施設（老健）',
                  '有料老人ホーム',
                  'デイサービス（通所介護）',
                  'グループホーム（認知症対応型共同生活介護）',
                ].map((item, i) => (
                  <li key={i} className="flex items-start gap-3 text-base font-semibold text-slate-800">
                    <span className="flex-shrink-0 w-6 h-6 rounded-full bg-orange-500 text-white text-xs font-bold flex items-center justify-center mt-0.5">
                      {i + 1}
                    </span>
                    {item}
                  </li>
                ))}
              </ol>
              <p className="text-sm text-gray-500 mt-4 pt-4 border-t border-gray-100">
                上記を含む介護施設全般でご利用いただけます。
              </p>
            </div>

            {/* 医療系施設 */}
            <div className="bg-white rounded-2xl p-8">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-orange-100">
                  <i className="ri-hospital-line text-orange-500 text-xl"></i>
                </div>
                <h3 className="text-lg font-bold text-slate-800">対象となる医療系施設</h3>
              </div>
              <ol className="space-y-3 mb-4">
                {[
                  '病院（リハビリ・口腔関連）',
                  'クリニック（歯科・内科等）',
                  '訪問看護ステーション',
                ].map((item, i) => (
                  <li key={i} className="flex items-start gap-3 text-base font-semibold text-slate-800">
                    <span className="flex-shrink-0 w-6 h-6 rounded-full bg-orange-500 text-white text-xs font-bold flex items-center justify-center mt-0.5">
                      {i + 1}
                    </span>
                    {item}
                  </li>
                ))}
              </ol>
              <p className="text-sm text-gray-500 mt-4 pt-4 border-t border-gray-100">
                上記を含む医療施設全般でご利用いただけます。
              </p>
            </div>
          </div>

          {/* 活用目的 */}
          <div className="bg-white rounded-2xl p-8">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-orange-100">
                <i className="ri-lightbulb-line text-orange-500 text-xl"></i>
              </div>
              <h3 className="text-lg font-bold text-slate-800">活用目的</h3>
            </div>
            <p className="text-sm text-gray-700 leading-relaxed mb-3">
              パタカラ®は、現場の「レクリエーション不足」および「口腔ケアの継続課題」に対応するプログラムとして、多くの施設で活用されています。
            </p>
            <p className="text-xs text-gray-500">
              ※本サービスは医療行為ではありません。各施設の判断および責任のもとでご活用ください。
            </p>
          </div>
        </div>
      </section>

      {/* 4コマ漫画セクション */}
      <section className="py-16 md:py-20 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-slate-800 text-center mb-10 md:mb-12">
            「パタカラ®」を安心してご利用いただくために
          </h2>

          {/* 横スクロール対応画像コンテナ */}
          <div className="overflow-x-auto pb-4 mb-8 -mx-6 px-6 md:mx-0 md:px-0">
            <div className="min-w-[800px] md:min-w-0 md:w-full max-w-[1200px] mx-auto">
              <img
                src="https://storage.helloreaddy.io/project_files/b895c287-4223-4b9b-9456-2e4b57b1eb08/639f1537-70b3-4139-a512-b7faf4da6786_compressed_paakara_4koma.webp"
                alt="パタカラ®が株式会社パックスシステムズの登録商標であることと、安心して利用するための許諾について説明する4コマ漫画"
                className="w-full h-auto object-contain rounded-xl cursor-pointer shadow-sm"
                onClick={() => setIsComicModalOpen(true)}
              />
            </div>
          </div>

          <p className="text-center text-gray-700 mb-8 max-w-3xl mx-auto leading-relaxed text-sm md:text-base">
            「パタカラ®」の名称やロゴを、施設のサービス、プログラム、WEBサイト、パンフレット等で使用する場合は、公式施設ライセンスをご確認ください。
          </p>

          <div className="flex items-center justify-center">
            <Link
              to="/license-application"
              className="px-8 py-3 bg-orange-500 text-white font-semibold rounded-full hover:bg-orange-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              パタカラ公式ライセンスを取得する
            </Link>
          </div>
        </div>

        {/* ライトボックス */}
        {isComicModalOpen && (
          <div
            className="fixed inset-0 z-[60] bg-black/80 flex items-center justify-center p-4"
            onClick={() => setIsComicModalOpen(false)}
          >
            <div className="relative max-w-full max-h-full">
              <button
                onClick={() => setIsComicModalOpen(false)}
                className="absolute -top-12 right-0 text-white text-2xl hover:text-gray-300 transition-colors cursor-pointer"
              >
                <i className="ri-close-line"></i>
              </button>
              <img
                src="https://storage.helloreaddy.io/project_files/b895c287-4223-4b9b-9456-2e4b57b1eb08/639f1537-70b3-4139-a512-b7faf4da6786_compressed_paakara_4koma.webp"
                alt="パタカラ®が株式会社パックスシステムズの登録商標であることと、安心して利用するための許諾について説明する4コマ漫画"
                className="max-w-full max-h-[85vh] w-auto h-auto object-contain rounded-lg"
                onClick={(e) => e.stopPropagation()}
              />
            </div>
          </div>
        )}
      </section>

      {/* Overview Section */}
      <section id="overview" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
            <div className="lg:col-span-2">
              <h2 className="text-3xl font-serif font-bold text-slate-800 mb-6 leading-tight">
                パタカラ®公式ライセンスとは
              </h2>
              <p className="text-base text-gray-700 leading-relaxed mb-4">
                登録商標「パタカラ®」（登録第5657576号）の商標権者である株式会社パックスシステムズが、介護施設および医療施設に限定して許諾する商標使用ライセンス（表示制度）です。
              </p>
              <p className="text-base text-gray-700 leading-relaxed">
                月額770円（税込）で、登録商標「パタカラ®」の正式な使用許諾を取得することができます。
              </p>
              <p className="text-base text-gray-700 leading-relaxed mt-4">
                パタカラ®公式ライセンスとは、商標権者から正式に商標使用許諾を受けた施設のみがパタカラ®をご使用頂けます。
              </p>
              <p className="text-base text-gray-700 leading-relaxed mt-4">
                介護施設・医療施設において、パタカラを使用する場合は、必ずパタカラ®公式ライセンスが必要です。（施設での紙資料・WEB掲載・施設でのカラオケを使用したプログラム・口腔体操として実施など）
              </p>
            </div>
            
            <div className="lg:col-span-3">
              <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-3xl p-10 shadow-lg">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
                  <div>
                    <img 
                      src="https://static.readdy.ai/image/1827e98d95d9f7558266c3fb82d75725/046350913d3243a7473eede9a6500d45.png" 
                      alt="パタカラ®ロゴ" 
                      className="w-full h-auto object-contain"
                    />
                  </div>
                  <div className="space-y-4">
                    <div className="flex items-start gap-3">
                      <div className="w-6 h-6 rounded-full bg-orange-500 text-white text-xs font-bold flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className="ri-check-line text-white text-sm"></i>
                      </div>
                      <p className="text-sm text-gray-800 font-medium">パタカラ®登録商標の使用権</p>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-6 h-6 rounded-full bg-orange-500 text-white text-xs font-bold flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className="ri-check-line text-white text-sm"></i>
                      </div>
                      <p className="text-sm text-gray-800 font-medium">公式施設認定証の発行</p>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-6 h-6 rounded-full bg-orange-500 text-white text-xs font-bold flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className="ri-check-line text-white text-sm"></i>
                      </div>
                      <p className="text-sm text-gray-800 font-medium">施設のブランド明確化</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl font-serif font-bold text-slate-800 text-center mb-16">
            公式ライセンスでできること
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-2xl p-10 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer">
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6">
                <i className="ri-trademark-line text-6xl text-orange-500"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-800 text-center mb-4">パタカラ®登録商標使用</h3>
              <p className="text-sm text-gray-600 text-center leading-relaxed">
                使用ガイドラインの範囲内で、パタカラ®及びロゴを施設の広報物やウェブサイトに使用できます。カラオケを使用したパタカラ体操や、口腔体操などでパタカラをお使い頂けます。（パタカラ®は、無許可での使用は禁止されています。）
              </p>
            </div>
            
            <div className="bg-white rounded-2xl p-10 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer">
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6">
                <i className="ri-award-line text-6xl text-orange-500"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-800 text-center mb-4">認定証表示</h3>
              <p className="text-sm text-gray-600 text-center leading-relaxed">
                PDF形式の公式施設認定証が発行され、施設内での掲示や対外的な信頼性の証明に活用できます。
              </p>
            </div>
            
            <div className="bg-white rounded-2xl p-10 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer">
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6">
                <i className="ri-building-line text-6xl text-orange-500"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-800 text-center mb-4">施設表示</h3>
              <p className="text-sm text-gray-600 text-center leading-relaxed">
                「パタカラ®公式施設」として対外的に表示でき、施設のブランド価値向上に貢献します。
              </p>
            </div>
          </div>

          <div className="mt-16 max-w-4xl mx-auto">
            <div className="bg-white rounded-2xl p-8 shadow-sm">
              <table className="w-full">
                <thead>
                  <tr className="border-b-2 border-gray-200">
                    <th className="text-left py-4 px-6 text-sm font-bold text-slate-800">項目</th>
                    <th className="text-center py-4 px-6 text-sm font-bold text-slate-800">公式施設</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-gray-100">
                    <td className="py-4 px-6 text-sm text-gray-700">パタカラ®登録商標使用</td>
                    <td className="py-4 px-6 text-center">
                      <span className="inline-flex items-center gap-2 text-sm font-medium text-green-600">
                        <i className="ri-check-line"></i>
                        使用可能（ガイドライン内）
                      </span>
                    </td>
                  </tr>
                  <tr className="border-b border-gray-100">
                    <td className="py-4 px-6 text-sm text-gray-700">認定証表示</td>
                    <td className="py-4 px-6 text-center">
                      <span className="inline-flex items-center gap-2 text-sm font-medium text-green-600">
                        <i className="ri-check-line"></i>
                        PDF認定証発行
                      </span>
                    </td>
                  </tr>
                  <tr className="border-b border-gray-100">
                    <td className="py-4 px-6 text-sm text-gray-700">施設表示</td>
                    <td className="py-4 px-6 text-center">
                      <span className="inline-flex items-center gap-2 text-sm font-medium text-green-600">
                        <i className="ri-check-line"></i>
                        「パタカラ®公式施設」表示可
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td className="py-4 px-6 text-sm text-gray-700">提供物</td>
                    <td className="py-4 px-6 text-center text-sm text-gray-700">
                      ロゴデータ・認定証
                    </td>
                  </tr>
                </tbody>
              </table>
              <p className="mt-6 text-xs text-gray-500 text-center">
                ※非許諾施設は「パタカラ®公式施設」の表示および公式ロゴの使用はできません。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Details Section */}
      <section id="details" className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-4xl font-serif font-bold text-slate-800 text-center mb-16">
            ライセンス内容詳細
          </h2>
          
          <div className="grid grid-cols-1 lg:grid-cols-11 gap-10">
            <div className="lg:col-span-6">
              <h3 className="text-2xl font-bold text-slate-800 mb-6">提供内容</h3>
              <div className="space-y-4">
                <div className="flex items-start gap-4">
                  <div className="w-3 h-3 rounded-full bg-orange-500 flex-shrink-0 mt-2"></div>
                  <p className="text-base text-gray-700 leading-relaxed">
                    <strong className="font-semibold">公式施設認定証</strong>（PDF形式）
                  </p>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-3 h-3 rounded-full bg-orange-500 flex-shrink-0 mt-2"></div>
                  <p className="text-base text-gray-700 leading-relaxed">
                    <strong className="font-semibold">パタカラ®ロゴデータ</strong>
                  </p>
                </div>
              </div>
              
              <div className="mt-10 p-6 bg-gray-50 rounded-xl">
                <p className="text-sm text-gray-700 leading-relaxed mb-3">
                  本ライセンスは、登録商標「パタカラ®」の商標使用許諾契約です。
                </p>
                <p className="text-sm text-gray-600 leading-relaxed">
                  介護施設および医療施設における表示利用を目的とし、各施設の責任のもとでご活用ください。
                </p>
              </div>

              <div className="mt-6 p-6 bg-orange-50 rounded-xl border border-orange-100">
                <h4 className="text-sm font-bold text-slate-800 mb-4 flex items-center gap-2">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-file-list-3-line text-orange-500 text-base"></i>
                  </div>
                  登録商標に係る下記指定役務にのみ使用できます。
                </h4>
                <div className="space-y-3">
                  <div className="flex items-start gap-2">
                    <span className="text-xs font-bold text-orange-600 bg-orange-100 rounded px-1.5 py-0.5 flex-shrink-0 mt-0.5">第41類</span>
                    <p className="text-xs text-gray-700 leading-relaxed">
                      音楽に関する知識の教授、映画・演芸・演劇又は音楽の演奏の興行の企画又は運営、音楽の演奏、音響用又は映像用のスタジオの提供、カラオケ施設の提供、映画・演芸・演劇・音楽又は教育研修のための施設の提供、楽器の貸与、レコード又は録音済み磁気テープの貸与
                    </p>
                  </div>
                  <div className="flex items-start gap-2">
                    <span className="text-xs font-bold text-orange-600 bg-orange-100 rounded px-1.5 py-0.5 flex-shrink-0 mt-0.5">第44類</span>
                    <p className="text-xs text-gray-700 leading-relaxed">
                      介護、医療施設における医療、医業、医療情報の提供、健康診断、調剤、栄養の指導
                    </p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="lg:col-span-5">
              <div className="bg-gradient-to-br from-red-50 to-orange-50 rounded-2xl p-8 border-l-4 border-orange-500">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-10 h-10 rounded-full bg-orange-500 flex items-center justify-center flex-shrink-0">
                    <i className="ri-alert-line text-white text-xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-slate-800">重要事項</h3>
                </div>
                
                <div className="space-y-3">
                  <div className="flex items-start gap-3">
                    <i className="ri-checkbox-blank-circle-fill text-orange-400 text-xs mt-1.5 flex-shrink-0"></i>
                    <p className="text-sm text-gray-700 leading-relaxed">
                      本ライセンスは商標使用許諾のみです。
                    </p>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-checkbox-blank-circle-fill text-orange-400 text-xs mt-1.5 flex-shrink-0"></i>
                    <p className="text-sm text-gray-700 leading-relaxed">
                      指導、教材、音源、CD等は含まれません。
                    </p>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-checkbox-blank-circle-fill text-orange-400 text-xs mt-1.5 flex-shrink-0"></i>
                    <p className="text-sm text-gray-700 leading-relaxed">
                      医療行為・治療行為を許可するものではありません。
                    </p>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-checkbox-blank-circle-fill text-orange-400 text-xs mt-1.5 flex-shrink-0"></i>
                    <p className="text-sm text-gray-700 leading-relaxed">
                      医療的効果、治療効果を保証するものではありません。
                    </p>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-checkbox-blank-circle-fill text-orange-400 text-xs mt-1.5 flex-shrink-0"></i>
                    <p className="text-sm text-gray-700 leading-relaxed">
                      各施設の責任のもとでご活用ください。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Application Flow Section */}
      <section id="flow" className="py-20 bg-gradient-to-b from-orange-50 to-white">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-4xl font-serif font-bold text-slate-800 text-center mb-16">
            申込の流れ
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
            <div className="text-center">
              <div className="w-20 h-20 rounded-full bg-orange-500 text-white text-3xl font-black flex items-center justify-center mx-auto mb-4 shadow-lg">
                1
              </div>
              <h3 className="text-base font-bold text-slate-800 mb-2">事前申込み</h3>
              <p className="text-xs text-gray-600 leading-relaxed">
                サイト内の申込みフォームに必要事項を入力して送信します。
              </p>
            </div>
            
            <div className="text-center relative">
              <div className="hidden md:block absolute top-10 -left-6 text-gray-300">
                <i className="ri-arrow-right-line text-2xl"></i>
              </div>
              <div className="w-20 h-20 rounded-full bg-orange-500 text-white text-3xl font-black flex items-center justify-center mx-auto mb-4 shadow-lg">
                2
              </div>
              <h3 className="text-base font-bold text-slate-800 mb-2">施設・利用内容の確認</h3>
              <p className="text-xs text-gray-600 leading-relaxed">
                株式会社パックスシステムズが施設・事業所の情報および利用内容を確認します。
              </p>
            </div>
            
            <div className="text-center relative">
              <div className="hidden md:block absolute top-10 -left-6 text-gray-300">
                <i className="ri-arrow-right-line text-2xl"></i>
              </div>
              <div className="w-20 h-20 rounded-full bg-orange-500 text-white text-3xl font-black flex items-center justify-center mx-auto mb-4 shadow-lg">
                3
              </div>
              <h3 className="text-base font-bold text-slate-800 mb-2">会費ペイ登録案内</h3>
              <p className="text-xs text-gray-600 leading-relaxed">
                確認後、担当者よりメールで会費ペイの決済・登録URLをご案内します。
              </p>
            </div>
            
            <div className="text-center relative">
              <div className="hidden md:block absolute top-10 -left-6 text-gray-300">
                <i className="ri-arrow-right-line text-2xl"></i>
              </div>
              <div className="w-20 h-20 rounded-full bg-orange-500 text-white text-3xl font-black flex items-center justify-center mx-auto mb-4 shadow-lg">
                4
              </div>
              <h3 className="text-base font-bold text-slate-800 mb-2">認定証発行</h3>
              <p className="text-xs text-gray-600 leading-relaxed">
                会費ペイでの登録完了後、公式施設ライセンスを発行します。
              </p>
            </div>
          </div>
          
          <p className="text-sm text-gray-500 text-center font-bold">
            ※事前申込みの内容を確認後、メールで会費ペイの登録方法をご案内します。<br />
            ※当社にて介護施設・医療施設であることを確認します。<br />
            ※パタカラ公式ライセンス契約は、弊社と利用者との契約になります。決済システムのみ、会費ペイを利用しています。
          </p>
          <div className="flex justify-center mt-4">
            <div className="w-48 h-16">
              <img
                src="https://static.readdy.ai/image/1827e98d95d9f7558266c3fb82d75725/f1d3a61b4af7f93daedc9f248934ac4c.png"
                alt="会費ペイ"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section id="faq" className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="text-4xl font-serif font-bold text-slate-800 text-center mb-16">
            よくある質問
          </h2>
          
          <div className="space-y-4">
            {[
              {
                question: 'なぜ「パタカラ」の使用にライセンスが必要なのですか？',
                answer: '「パタカラ」は、株式会社パックスシステムズが保有する法的な登録商標（第5657576号）だからです。一般名詞（介護・医療用語）ではないため、営利目的（施設でのサービス提供、集客、WEBサイトやパンフレットへの掲載）で無断使用することは商標権侵害にあたる法的リスクがあります。当ライセンスは、施設様が安心・安全に、かつコンプライアンスを遵守して名称をご利用いただくための正規の使用許諾制度です。',
                logo: null
              },
              {
                question: '月額770円（税込）のほかに、初期費用や更新料はかかりますか？',
                answer: 'いいえ、初期費用や更新料などは一切かかりません。1施設あたり月額770円（税込）のみでご利用いただけます。また、最低利用期間などの「契約の縛り」もございませんので、いつでも解約が可能です。',
                logo: null
              },
              {
                question: 'ライセンスを契約すると、指導用の教材や音源、器具などは届きますか？',
                answer: '本ライセンスは「パタカラ®」の商標（名称・ロゴ）の使用許諾のみを提供するものです。そのため、実際の指導用マニュアル、教材、CD音源、または物理的なトレーニング器具などは含まれておりません。各施設様の責任のもとで、独自のレクリエーションや口腔機能向上サービスとして運用をお願いいたします。',
                logo: null
              },
              {
                question: '1つの法人で複数のデイサービスを運営している場合、契約は1つで足りますか？',
                answer: 'いいえ、本ライセンスは「1施設（1事業所）ごと」のご契約となります。同一法人であっても、運営されている施設・事業所の数だけライセンスのご契約が必要となりますのでご注意ください。',
                logo: null
              },
              {
                question: '申し込み後、公式施設認定証はいつ、どのように届きますか？',
                answer: 'Webからの決済手続きとお申し込みフォームへの入力が完了した後、弊社での確認を経て最短2営業日以内に、ご登録いただいたメールアドレス宛に「公式施設認定証（PDF形式）」と「ロゴデータ（JPG/PNG形式）」を送付いたします。PDFは印刷して施設内に掲示したり、ロゴはホームページに掲載してご活用いただけます。',
                logo: null
              },
              {
                question: '支払方法は？',
                answer: '「会費ペイ」のシステムを使用してお支払いください。',
                logo: 'https://static.readdy.ai/image/1827e98d95d9f7558266c3fb82d75725/f1d3a61b4af7f93daedc9f248934ac4c.png',
                subAnswer: 'クレジットカード決済（VISA / Mastercard / JCB / AMEX / Diners）および、口座振替（銀行口座からの自動引き落とし）に対応しております。決済システムには安心・安全な「会費ペイ」を採用しており、毎月の決済手続きはすべて自動で行われます。'
              },
              {
                question: '非営利の公共性の高い団体及び、官公庁に関してはライセンスが必要ですか？',
                answer: '非営利の公共性の高い団体及び、官公庁に関してもライセンスが必要です。非営利の健康増進・福祉活動等に限り、無償での商標使用許諾を検討しております。お問合せフォームよりご連絡ください。',
                logo: null
              },
              {
                question: '解約したい場合はどのようにすればよいですか？',
                answer: 'マイページ（会費ペイ等の決済画面）またはお問い合わせフォームより、解約希望月の指定期日までにお手続きいただくことで、いつでも違約金なしで解約が可能です。ただし、解約後は「パタカラ」の名称・ロゴ、および公式施設認定証は一切ご利用いただけなくなります（WEBサイトやパンフレットからの削除が必要です）。',
                logo: null
              }
            ].map((faq, index) => (
              <div 
                key={index}
                className="bg-gray-50 rounded-xl overflow-hidden transition-all duration-300"
              >
                <button
                  onClick={() => toggleFaq(index)}
                  className="w-full px-6 py-5 flex items-start justify-between gap-4 text-left hover:bg-gray-100 transition-colors cursor-pointer"
                >
                  <div className="flex items-start gap-4 flex-1">
                    <div className="w-8 h-8 rounded-full bg-gray-400 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <span className="text-white text-sm font-bold">Q</span>
                    </div>
                    <p className="text-base font-bold text-slate-800 leading-relaxed pt-1">
                      {faq.question}
                    </p>
                  </div>
                  <i className={`ri-arrow-down-s-line text-2xl text-gray-400 transition-transform duration-300 flex-shrink-0 ${openFaq === index ? 'rotate-180' : ''}`}></i>
                </button>
                
                <div 
                  className={`overflow-hidden transition-all duration-300 ${openFaq === index ? 'max-h-[500px]' : 'max-h-0'}`}
                >
                  <div className="px-6 pb-5 space-y-4">
                    <div className="flex items-start gap-4">
                      <div className="w-8 h-8 rounded-full bg-gray-400 flex items-center justify-center flex-shrink-0">
                        <span className="text-white text-sm font-bold">A</span>
                      </div>
                      <div className="pt-1 flex-1">
                        <p className="text-base text-gray-700 leading-relaxed whitespace-pre-line">
                          {faq.answer}
                        </p>
                        {faq.logo && (
                          <div className="mt-4 w-48 h-16">
                            <img
                              src={faq.logo}
                              alt="会費ペイ"
                              className="w-full h-full object-contain object-left"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    {faq.subAnswer && (
                      <div className="flex items-start gap-4">
                        <div className="w-8 h-8 rounded-full bg-gray-400 flex items-center justify-center flex-shrink-0">
                          <span className="text-white text-sm font-bold">B</span>
                        </div>
                        <p className="text-base text-gray-700 leading-relaxed pt-1">
                          {faq.subAnswer}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Application Form Section */}
      <section id="application-form" className="py-20 bg-gradient-to-br from-orange-500 to-orange-600">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <h2 className="text-5xl font-serif font-bold text-white mb-4">
            今すぐパタカラ®公式ライセンスを取得する
          </h2>
          <p className="text-xl text-white/90 mb-10">
            月額770円（税込）
          </p>
          
          <Link
            to="/license-application"
            className="inline-flex items-center gap-3 px-16 py-6 bg-white text-orange-600 text-lg font-bold rounded-full shadow-2xl whitespace-nowrap cursor-pointer hover:bg-orange-50 transition-colors"
          >
            申込フォームへ進む
            <i className="ri-arrow-right-line text-2xl"></i>
          </Link>

          <p className="mt-6 text-sm text-white/80">
            ＊事前申込みの内容を確認後、メールで会費ペイの登録方法をご案内します。
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-900 text-white pt-16 pb-8">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
            <div>
              <img 
                src="https://static.readdy.ai/image/1827e98d95d9f7558266c3fb82d75725/927c3b547f45ed1f38c15098c60865bf.png" 
                alt="パタカラ®ロゴ" 
                className="h-10 w-auto object-contain mb-4 bg-white rounded-lg p-1.5"
              />
              <p className="text-sm text-gray-400 leading-relaxed">
                介護施設・医療施設向けの公式ライセンスサービス
              </p>
            </div>
            
            <div>
              <h4 className="text-xs font-bold text-gray-400 uppercase mb-4 tracking-wider">サービス</h4>
              <ul className="space-y-3">
                <li><a href="#overview" className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">概要</a></li>
                <li><a href="#features" className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">できること</a></li>
                <li><a href="#details" className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">詳細</a></li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-xs font-bold text-gray-400 uppercase mb-4 tracking-wider">サポート</h4>
              <ul className="space-y-3">
                <li><a href="#flow" className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">申込の流れ</a></li>
                <li><a href="#faq" className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">よくある質問</a></li>
                <li><Link to="/trademark-guidelines" className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">商標利用ガイドライン</Link></li>
                <li><Link to="/terms" className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">利用規約</Link></li>
                <li><Link to="/contact" className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">お問い合わせ</Link></li>

              </ul>
            </div>
            
            <div>
              <h4 className="text-xs font-bold text-gray-400 uppercase mb-4 tracking-wider">会社情報</h4>
              <p className="text-sm text-gray-400 leading-relaxed mb-2">
                株式会社パックスシステムズ
              </p>
              <p className="text-xs text-gray-500 leading-relaxed mb-3">
                担当：関<br />
                〒231-0023<br />
                横浜市中区山下町1番地<br />
                シルクセンターM1F<br />
                TEL: 045-681-3165<br />
                FAX: 045-681-3173<br />
                メール：info@patakara.org
              </p>
              <p className="text-xs text-gray-500 leading-relaxed">
                登録商標「パタカラ®」<br />
                登録第5657576号
              </p>
            </div>
          </div>
          
          <div className="border-t border-gray-800 pt-8">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4">
              <div className="text-sm text-gray-500 space-y-1">
                <p>© 2026 Pax Systems Co., Ltd. All rights reserved.</p>
                <p className="text-xs text-gray-500">「パタカラ®」は株式会社パックスシステムズの登録商標です（登録第5657576号）。</p>
                <p className="text-xs text-gray-500">本サイトは登録商標の指定役務の範囲内におけるライセンス提供について案内するものです。</p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
